<!-- bg-transparent overrides UA [popover]:popover-open { background: Canvas } -->
<div
    #layer
    class="fixed inset-0 h-full w-full bg-transparent"
    popover="manual"
    [ngClass]="layerService.customClass$() | async"
></div>
